"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Logger = _interopRequireDefault(require("./Logger"));

function capitalize() {
  var str = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';

  if (typeof str === 'string') {
    return "".concat(str[0].toUpperCase()).concat(str.slice(1));
  } else {
    _Logger["default"].error("The parameter '".concat(str, "' provided to capitalize function is invalid."));

    return '';
  }
}

var _default = capitalize;
exports["default"] = _default;